import { render, staticRenderFns } from "./DetailPurchaseOtherInvoice.vue?vue&type=template&id=5d26fbb4"
import script from "./DetailPurchaseOtherInvoice.vue?vue&type=script&lang=js"
export * from "./DetailPurchaseOtherInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports